<!--
 * @Author: kunlv kunlv@iflytek.com
 * @Date: 2026-01-16 15:29:30
 * @LastEditors: kunlv kunlv@iflytek.com
 * @LastEditTime: 2026-01-19 10:58:10
 * @FilePath: \ai-official-yg\src\components\pageHeader.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-header">
    <img
      class="page-header__logo"
      alt=""
      src="@/assets/images/home/logo.png"
      @click="handleClick"
    />
  </div>
</template>
<script>
export default {
  name: "PageHeader",
  methods: {
    handleClick() {
      this.$router.push("/");
    }
  }
}
</script>
<style lang="scss" scoped>
.page-header {
  padding: 0 var(--page-padding);
    display: flex;
    align-items: center;
    height: 60px;
    min-height: 60px;
    background: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(56, 54, 54, 0.05);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    box-sizing: border-box;
    &__logo {
      height: 32px;
      width: auto;

      cursor: pointer;
    }
}
</style>